const level = require('level-js')
const Cache = require('./Cache')
module.exports = Cache(level)
